import { render, staticRenderFns } from "./StringCategories.vue?vue&type=template&id=6a4a69a0&"
import script from "./StringCategories.vue?vue&type=script&lang=js&"
export * from "./StringCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports